
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_17oho_5eh15_5",
  "anchor-list": "awsui_anchor-list_17oho_5eh15_9",
  "anchor-item--active": "awsui_anchor-item--active_17oho_5eh15_13",
  "anchor-link": "awsui_anchor-link_17oho_5eh15_17",
  "anchor-link-text": "awsui_anchor-link-text_17oho_5eh15_21",
  "anchor-link-info": "awsui_anchor-link-info_17oho_5eh15_25"
};
  